import { gql } from '@apollo/client';

export const DASHBOARD_OUTSTANDING_DSD_ASSESSMENTS = gql`
  query OutstandingDSDAssessments($input: DashboardFilterArgs) {
    totalOutstandingDsdAssessments(input: $input) {
      name
      outstandingDays
    }
  }
`;
